import createReducer from 'lib/createReducer';


export const SAVE_NAVIGATION_INFO = 'SAVE_NAVIGATION_INFO';


const initialState = {
  prevPage: {
    cfi: '',
    chapterTitle: ''
  },
  currentPage: {
    cfi: '',
    chapterTitle: ''
  },
  nextPage: {
    cfi: '',
    chapterTitle: ''
  }
};

const actionHandlers = {
  [SAVE_NAVIGATION_INFO]: (state, action) => {
    return {
      prevPage: { ...action.data.prevPageInfo },
      currentPage: { ...action.data.currentPage },
      nextPage: { ...action.data.nextPageInfo }
    };
  }
};


export default createReducer(initialState, actionHandlers);
